import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common'; // Importante para *ngFor
import { ProductosService } from './productos.service'; // Ajusta la ruta
import { Categoria, Producto } from './interfaces';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-productos',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './productos.html',
  styleUrls: ['./productos.css']
})
export class ProductosComponent implements OnInit {
  
  categorias: Categoria[] = [];
  productosMostrados: Producto[] = [];
  
  categoriaSeleccionadaId: string = 'electrobombas'; // Categoría por defecto
  categoriaActual: Categoria | undefined;

  dropdownAbierto: boolean = false; // Para el menú móvil

  constructor(private productosService: ProductosService) {}

  ngOnInit() {
    // 1. Cargar categorías
    this.categorias = this.productosService.getCategorias();
    
    // 2. Cargar productos iniciales
    this.cambiarCategoria(this.categoriaSeleccionadaId);
  }

  cambiarCategoria(id: string) {
    this.categoriaSeleccionadaId = id;
    this.categoriaActual = this.categorias.find(c => c.id === id);
    this.productosMostrados = this.productosService.getProductosPorCategoria(id);
    this.dropdownAbierto = false; // Cerrar dropdown al seleccionar
  }

  toggleDropdown() {
    this.dropdownAbierto = !this.dropdownAbierto;
  }
}
